import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3>{`Syria`}</h3>
    <p>{`The conflict in Syria entered its ninth year in 2019, taking a devastating toll on the lives of Syrian people. Soaring food and fuel prices, stagnant salaries, loss of livelihoods and reduced food production led to widespread food insecurity across the country. Support from donors such as the EU helped WFP reach those most in need, providing some `}<a parentName="p" {...{
        "href": "https://www.wfp.org/operations/annual-country-report/?operation_id=SY02&year=2019#/15940"
      }}>{`6.7 million`}</a>{` people with food assistance last year.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      